export { QuicklinkModule } from './quicklink.module';
export { QuicklinkStrategy } from './quicklink-strategy.service';
//# sourceMappingURL=index.js.map